import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useStaticData } from "modules/MasterData/service/staticData.hooks";

import React, { useEffect } from "react";
import { toTitleCase } from "utils/utils";

export const PromoCategorySelect = (props: {
  error?: string;
  value: string;
  disabled?: boolean;
  spendCat3Id?: string;
  onChange: (e: any) => void;
  qualityApprovalRequired?: (e: any) => void;
}) => {
  const {taxonomy, promoCategoryTypes} = useStaticData();
  

  useEffect(() => {
    if (props.value && props.qualityApprovalRequired) {
      props.qualityApprovalRequired(
        taxonomy.find((c) => c.id === props.value)?.qualityControl
      );
    }
  }, [props.value]);
  // Filter available categories
  const availableCategories = taxonomy.filter((c) => {
    const hasValidPromoCategoryType = promoCategoryTypes.some(type => type.id === c.promoCategoryType);
    const hasMatchingSpendCat3 = c.spendCategoryL3?.id == props.spendCat3Id;
    
    return hasValidPromoCategoryType && hasMatchingSpendCat3;
  });

  return (
    <FormControl fullWidth size="small" disabled={props.disabled}>
      <InputLabel id="grouped-select-label">{`Sub Category *`}</InputLabel>
      <Select
        required={true}
        labelId="grouped-select-label"
        id="grouped-select"
        label="Sub Category"
        error={!!props.error}
        value={props.value || ""}
        disabled={props.disabled}
        onChange={(e) => {
          const selectedCategory = taxonomy.find((c) => c.id == e.target.value);
          if (selectedCategory) {
            props.onChange(selectedCategory);
          }
        }}
        renderValue={(value) => (
          <>
            {toTitleCase(
              taxonomy.find((c) => c.id === value)?.name || ""
            )}
          </>
        )}
      >
        {promoCategoryTypes.map((type) => {
          const categoriesForType = availableCategories.filter(
            (c) => c.promoCategoryType === type.id
          );
          
          if (categoriesForType.length === 0) {
            return null;
          }
          
          return [
            <MenuItem key={`header-${type.id}`} disabled sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
              {type.name}
            </MenuItem>,
            // Category items
            ...categoriesForType.map((category) => (
              <MenuItem 
                value={category.id} 
                key={category.id}
                sx={{ pl: 4 }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box
                    sx={{
                      width: "24px",
                      height: "24px",
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '& svg': { width: '100%', height: '100%' },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: category.icon,
                    }}
                  />
                  {toTitleCase(category.name)}
                </Box>
              </MenuItem>
            ))
          ];
        })}
      </Select>
      {!!props.error && <FormHelperText error>{props.error}</FormHelperText>}
    </FormControl>
  );
};

export default PromoCategorySelect;
